<template>
  <div>
    <div class="container-fluid bg"></div>
    <div class="container">
      <div class="row content">
        <div class="col-md-12 text-justify">
          <h1 class="centered">Курсы</h1>
          <br>
          <p class="font-italic">
            «Курсы экскурсоводов по Санкт-Петербургу» – это образовательный проект 
            <!--Дворца учащейся молодежи--> для тех, кто хочет сделать хобби своей основной профессией
            и пополнить арсенал своих знаний.
          </p>
          <p>
            Обучение на наших курсах экскурсоводов  открывает потрясающие перспективы перед каждым слушателем:
          </p>
          <ul>
            <li>показать множеству людей Санкт-Петербург таким, каким его видите Вы!</li>
            <li>расширить свой кругозор</li>
            <li>получать знания по истории, культуре, архитектуре  и экскурсоведению  от лучших специалистов Санкт-Петербурга</li>
            <li>получить аккредитацию  в Городском  туристско-информационном  центре</li>
            <li>возможность трудоустройства  в  компанию по приему туристов в Санкт-Петербурге</li>
            <li>существенно увеличить доход в период летних и зимних каникул, совмещая любимое хобби с работой</li>
          </ul>
          <p>
            Наши курсы — это действительно фундаментальное образование, а не поверхностный
            взгляд на историю и культуру нашего города. Своей миссией мы считаем формирование
            нового поколения петербургских экскурсоводов для поддержания традиций и культуры нашего города.
          </p>
          <p class="font-italic">
            <i class="fa fa-exclamation" aria-hidden="true" style="color:red; font-size:20px;"></i>
            Мы позаботились о том, чтобы занятия начинались в удобное для работающего человека время,
            а также о том, чтобы Вам было удобно до нас добираться. И каждого, кто изучал стоимость обучения профессии
            экскурсоводов, обязательно порадует сочетание цены и качества обучения на наших курсах.
          </p>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  background-image: url(../assets/books.jpeg);
  background-position: 50% 70%;
  background-size: cover;
  height: 40vh;
}
</style>



// WEBPACK FOOTER //
// AboutCourses.vue?5a73a330